import type { BalanceTableOptsState } from 'src/store/shared/balance-table-opts/types';

export interface Store {
  loans: {
    balancesUI: BalanceTableOptsState;
  };
}

export const selectIsDuplicatesVisible = (store: Store) =>
  store.loans.balancesUI.isDuplicatesVisible;
export const selectIsInitialBalanceUsed = (store: Store) =>
  store.loans.balancesUI.isInitialBalanceUsed;
export const selectViewMode = (store: Store) => store.loans.balancesUI.viewMode;
export const showCurrentAccounts = (store: Store) => store.loans.balancesUI.showCurrentAccounts;
export const selectViewGroupBy = (store: Store) => store.loans.balancesUI.viewGroupBy;
export const selectViewChartGroupBy = (store: Store) => store.loans.balancesUI.viewChartGroupBy;
export const selectShowSelectedBalance = (store: Store) =>
  store.loans.balancesUI.showSelectedBalance;
export const selectViewCumulativeBalance = (store: Store) =>
  store.loans.balancesUI.viewCumulativeBalance;
export const selectViewTarget = (store: Store) => store.loans.balancesUI.viewTarget;
export const selectViewRounding = (store: Store) => store.loans.balancesUI.viewRounding;
export const selectIsSmallBalancesVisible = (store: Store) =>
  store.loans.balancesUI.isSmallBalancesVisible;

export const selectShouldShowFullName = (store: Store) => store.loans.balancesUI.shouldShowFullName;

export const selectIsIgnoreOtherTokens = (store: Store) =>
  store.loans.balancesUI.isIgnoreOtherTokens;

export const selectIgnoreTokens = (store: Store) => store.loans.balancesUI.ignoreTokens;

export const selectShowDetails = (store: Store) => store.loans.balancesUI.showDetails;

export const selectShowErrorAccounts = (store: Store) => store.loans.balancesUI.showErrorAccounts;

export const selectExcludeFuturesFromSummary = (store: Store) =>
  store.loans.balancesUI.excludeFuturesFromSummary;

export const selectApplyTokenMapping = (store: Store) => store.loans.balancesUI.applyTokenMapping;
